import Grading from '@mui/icons-material/Grading';
import { IconButton, Badge } from '@mui/material';
import { useContext } from 'react';
import { PANEL } from '@/contexts/UIState/types';
import { UIStateContext } from '@/contexts/UIState/context';
import { ChecklistContext } from '@/contexts/checklist/context';
import { darkTheme } from '@/contexts/theme/monitoringTool.theme';

export const CHECKLIST_BUTTON_LABEL = 'Checklist';

export const ChecklistButton = (props: { disabled?: boolean }) => {
  const { setOpenedPanel } = useContext(UIStateContext);
  const { checkboxes } = useContext(ChecklistContext);

  const getChecklistIconColor = (): string => {
    if (!checkboxes.length) return 'inherit';
    if (checkboxes.some(({ warnings }) => warnings.length > 0)) {
      return darkTheme.palette.error.main;
    }
    if (!checkboxes.some(({ isChecked }) => !isChecked)) {
      return darkTheme.palette.success.main;
    }
    return 'inherit';
  };
  const checkboxesToCheck = checkboxes.reduce((acc, checkbox) => {
    if (!checkbox.isChecked && !checkbox.isDisabled) {
      acc++;
    }
    return acc;
  }, 0);

  return (
    <IconButton
      sx={{
        color: getChecklistIconColor(),
        '&.Mui-disabled': {
          color: darkTheme.palette.secondary.main,
        },
      }}
      aria-label={CHECKLIST_BUTTON_LABEL}
      onClick={() => setOpenedPanel(PANEL.CHECKLIST)}
      {...props}
    >
      <Badge color='error' badgeContent={checkboxesToCheck}>
        <Grading />
      </Badge>
    </IconButton>
  );
};
